export interface SSOAuthResult {
  authResponse: {
    accessToken: string;
  };
}

export enum SSOLoginType {
  DEFAULT = 'DEFAULT',
  LIMITED = 'LIMITED',
}
